import React from 'react';
import { TimeAgo } from './TimeAgo';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';

const CallCardOrders = (props) => {
  const { event } = props;

  const { pointId, createdAt, details } = event;

  const hasPaymentCashRequest = details.payment && details.payment.cash;
  const hasPaymentCardRequest = details.payment && details.payment.card;
  const hasAnyPayment = hasPaymentCashRequest || hasPaymentCardRequest;

  let iconToShow = <CircleNotificationsIcon className="txt-white s-64-i" />;
  let message = 'GO TO';
  if (hasAnyPayment) {
    iconToShow = hasPaymentCashRequest ? (
      <LocalAtmIcon className="txt-success s-64-i" />
    ) : (
      <CreditCardIcon className="txt-info s-64-i" />
    );
    message = hasPaymentCashRequest ? 'PLATA CASH' : 'PLATA CARD';
  }

  return (
    <div className="p-rel f-c f-dirc f-jcsb m-4 W100 br-2 bg-yellow">
      <div className="f-c f-dirc f-jcsb f-aic H100" style={{ height: 128 }}>
        <div className="f-c f-dirc f-aic f-jcc mt-4">{iconToShow}</div>
        <span className="f3b f08 mt-8 ta-c f-1 txt-black">{message}</span>
        <TimeAgo className="f3b f07 ta-c f-1 txt-black" date={createdAt} />
      </div>
    </div>
  );
};

export { CallCardOrders };
